import React, { useState, useEffect } from "react";
import {UncontrolledTooltip, Row, Col, Button} from "reactstrap";

const Code = ({ code, viewingFull, editable, sendDataToParent, id, order, type }) => {
  const [localCode, setLocalCode] = useState('');
  const [copyStatus, setCopyStatus] = useState(false);

  useEffect(() => {
    setLocalCode(code);
  }, [code]);

  const handleChange = (e) => {
    setLocalCode(e.target.value);
  };

  const handleSave = () => {
    sendDataToParent(
      {
        id,
        code: localCode !== '' ? localCode : code,
        order: order,
      },
      type
    );
  };

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code + " Generated by Temperstack").then(
        () => {
          setCopyStatus(true);
          setTimeout(() => {
            setCopyStatus(false);
          }, 2000);
        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = code + " Generated by Temperstack";
      textArea.style.border = 'none';
      textArea.style.background = 'transparent';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopyStatus(true);
        setTimeout(() => {
          setCopyStatus(false);
        }, 2000);
      } catch (err) {
        console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div 
      className={`d-flex p-0 ${!editable && viewingFull ? 'px-4 py-4' : `${!editable && 'px-5 py-3'}`} mx-0 ${editable ? 'mb-0' : 'mb-4'}  w-100`}
      style={{ 
        borderRadius: "12px", 
        color: "#FFB680", 
        justifyContent: "space-between", 
        alignItems: "start",
        backgroundColor: `${editable ? 'transparent' : 'black'}`
      }}
    >
      <div style={{ flex: "1 1 75%", minWidth: "0" }}>
        {!editable ? (
          <p className='m-0' style={{ fontSize: "14px", fontWeight: "500" }}>{code}</p>
        ) : (
          <Row>
            <Col lg={1}>
              <p className="mt-2" style={{ color: "#DBE1F5" }}>Code:</p>
            </Col>
            <Col lg={11}>
              <input
                className="w-100 input"
                value={localCode}
                onChange={handleChange}
                onBlur={handleSave}
                style={{ color: "#FFB680", fontSize: "14px", minHeight: "20px" }}
              />
            </Col>
          </Row>
        )}
      </div>
      {!editable && (
        <div className="m-0 align-self-start d-flex">
          <div
            onClick={() => copyToClipboard()}
            className={`${copyStatus ? 'bx bxs-copy-alt' : 'bx bx-copy-alt'}`}
            style={{ fontSize: "24px", cursor: "pointer", color: `${copyStatus ? '#9EF3A1' : '#FFB680'}` }}
            id="code"
          ></div>
          <UncontrolledTooltip placement="left" target="code">Copy</UncontrolledTooltip>
        </div>
      )}
    </div>
  );
};

export default Code;

